import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { MultiLineEllipsisText } from '@bingads-webui-react/multiline-ellipsis';
import { withLink } from './with-link';
import type { UAPPlacementComponentProps } from '../@types';

export type PlacementTextProps = {
  text?: string;
  isMultiLine: boolean;
  placementTextClassName?: string;
};

export type PlacementHeadlineProps = Pick<UAPPlacementComponentProps, 'i18n'> & {
  headlineText?: string;
  isMultiLine?: boolean;
  placementHeadlineClassName?: string;
};

export type PlacementFinalUrlProps = {
  finalUrl?: string;
  displayUrl?: string;
  isMultiLine?: boolean;
  placementFinalUrlClassName?: string;
};

export type PlacementDescriptionProps = Pick<UAPPlacementComponentProps, 'i18n'> & {
  description?: string;
  isMultiLine?: boolean;
  placementDescriptionClassName?: string;
};

type PlacementTextRef = HTMLDivElement | MultiLineEllipsisText;

export const PlacementText = React.forwardRef<PlacementTextRef, PlacementTextProps>(({

  text,

  isMultiLine,

  placementTextClassName,
}, ref) => (
  isMultiLine ?
    <MultiLineEllipsisText

      ref={ref as React.Ref<MultiLineEllipsisText>}
      className={classnames(placementTextClassName)}
      text={text}
    /> : (
      <div ref={ref as React.Ref<HTMLDivElement>} className={placementTextClassName}>
        {text}
      </div>
    )
));

PlacementText.propTypes = {

  text: PropTypes.string,
  isMultiLine: PropTypes.bool.isRequired,
  placementTextClassName: PropTypes.string,
};

PlacementText.defaultProps = {

  placementTextClassName: undefined,
  text: undefined,
};


// --------------------------------------------------------------------------------
export const PlacementHeadline = React.forwardRef<HTMLDivElement, PlacementHeadlineProps>(({

  headlineText,

  isMultiLine,

  placementHeadlineClassName,
}, ref) => (
  <PlacementText
    ref={ref}

    isMultiLine={isMultiLine}
    text={headlineText}
    placementTextClassName={classnames(placementHeadlineClassName)}
  />
));

PlacementHeadline.propTypes = {

  headlineText: PropTypes.string,
  isMultiLine: PropTypes.bool,
  placementHeadlineClassName: PropTypes.string,
};

PlacementHeadline.defaultProps = {

  headlineText: undefined,
  isMultiLine: false,
  placementHeadlineClassName: undefined,
};

export const PlacementHeadlineWithLink = withLink(PlacementHeadline);


// --------------------------------------------------------------------------------
export const PlacementFinalUrl = React.forwardRef<HTMLDivElement, PlacementFinalUrlProps>(({

  isMultiLine,

  finalUrl,

  displayUrl,

  placementFinalUrlClassName,
}, ref) => (
  <PlacementText
    ref={ref}

    isMultiLine={isMultiLine}
    text={displayUrl || finalUrl}
    placementTextClassName={classnames(placementFinalUrlClassName)}
  />
));

PlacementFinalUrl.propTypes = {

  finalUrl: PropTypes.string,
  displayUrl: PropTypes.string,
  isMultiLine: PropTypes.bool,
  placementFinalUrlClassName: PropTypes.string,
};

PlacementFinalUrl.defaultProps = {

  finalUrl: undefined,
  displayUrl: undefined,
  placementFinalUrlClassName: undefined,
  isMultiLine: false,
};

export const PlacementFinalUrlWithLink = withLink(PlacementFinalUrl);


// --------------------------------------------------------------------------------
export const PlacementDescription = React.forwardRef<HTMLDivElement, PlacementDescriptionProps>(({

  description,

  isMultiLine,

  placementDescriptionClassName,
}, ref) => (
  <PlacementText
    ref={ref}

    isMultiLine={isMultiLine}
    text={description}
    placementTextClassName={classnames(placementDescriptionClassName)}
  />
));

PlacementDescription.propTypes = {

  description: PropTypes.string,
  isMultiLine: PropTypes.bool,
  placementDescriptionClassName: PropTypes.string,
};

PlacementDescription.defaultProps = {

  description: undefined,
  placementDescriptionClassName: undefined,
  isMultiLine: false,
};
